"use strict";
'use client';
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var next_intl_1 = require("next-intl");
var ui_components_1 = require("@l2p/ui-components");
var useBonusesCards_1 = require("./useBonusesCards");
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var BonusesCards = function () {
    var t = (0, next_intl_1.useTranslations)('translation');
    var _a = (0, useBonusesCards_1.useBonusesCards)(), bonusToActivate = _a.bonusToActivate, bonusToCancel = _a.bonusToCancel, sortedBonuses = _a.sortedBonuses, cancelBonusHandler = _a.cancelBonusHandler, closeCancelBonusModal = _a.closeCancelBonusModal, confirmCancelBonus = _a.confirmCancelBonus, isCancelingBonus = _a.isCancelingBonus, closeActivateBonusModal = _a.closeActivateBonusModal, confirmActivateBonus = _a.confirmActivateBonus, isActivateSubmitting = _a.isActivateSubmitting, activateBonusHandler = _a.activateBonusHandler, bonusToDirectActivation = _a.bonusToDirectActivation, isValidation = _a.isValidation, isLoading = _a.isLoading;
    if (isLoading || isValidation)
        return react_1.default.createElement(ui_components_1.LoadingWithContainer, null);
    if (sortedBonuses.length === 0)
        return (react_1.default.createElement("div", { className: styles_module_scss_1.default.emptyBonuses }, t('youDoNotHaveActiveBonuses')));
    return (react_1.default.createElement("div", { className: styles_module_scss_1.default.bonusesContainer },
        sortedBonuses.map(function (bonus, idx) { return (react_1.default.createElement(ui_components_1.BonusCard, __assign({ key: ((bonus === null || bonus === void 0 ? void 0 : bonus.id) || '') + idx }, bonus, { isActivateSubmitting: isActivateSubmitting, cancelBonus: cancelBonusHandler, activateBonus: activateBonusHandler, bonusToDirectActivation: bonusToDirectActivation }))); }),
        bonusToCancel && (react_1.default.createElement(ui_components_1.CancelBonusConfirmation, { type: "cancel", closeModal: closeCancelBonusModal, bonus: bonusToCancel, confirm: confirmCancelBonus, isLoading: isCancelingBonus })),
        bonusToActivate && (react_1.default.createElement(ui_components_1.CancelBonusConfirmation, { type: "activation", closeModal: closeActivateBonusModal, bonus: bonusToActivate, confirm: confirmActivateBonus, isLoading: isActivateSubmitting }))));
};
exports.default = BonusesCards;
